import hideOptionMenu from './wx/hideOptionMenu';
import share from './wx/share';
import {checkWxSDKReady,closeWindow} from './wx/util'
export default {
    hideOptionMenu,
    share,
    checkWxSDKReady,
    closeWindow
}